/**
 * Landcodes uit GTSKV TransportWebservice WSDL (Transport.Country).
 *
 * @see https://gtskv.skv.info/service/TransportService/V4/TransportWebservice.svc?xsd=xsd2
 */
export interface GtskvCountryOption {
  code: string;
  label: string;
}

export const GTSKV_COUNTRY_OPTIONS: GtskvCountryOption[] = [
  { code: 'AT', label: 'Oostenrijk' },
  { code: 'BE', label: 'België' },
  { code: 'BG', label: 'Bulgarije' },
  { code: 'CH', label: 'Zwitserland' },
  { code: 'CY', label: 'Cyprus' },
  { code: 'CZ', label: 'Tsjechië' },
  { code: 'DE', label: 'Duitsland' },
  { code: 'DK', label: 'Denemarken' },
  { code: 'EE', label: 'Estland' },
  { code: 'EN', label: 'Engeland' },
  { code: 'ES', label: 'Spanje' },
  { code: 'FI', label: 'Finland' },
  { code: 'FR', label: 'Frankrijk' },
  { code: 'GB', label: 'Verenigd Koninkrijk' },
  { code: 'GR', label: 'Griekenland' },
  { code: 'HU', label: 'Hongarije' },
  { code: 'IE', label: 'Ierland' },
  { code: 'IT', label: 'Italië' },
  { code: 'LT', label: 'Litouwen' },
  { code: 'LU', label: 'Luxemburg' },
  { code: 'LV', label: 'Letland' },
  { code: 'MT', label: 'Malta' },
  { code: 'NL', label: 'Nederland' },
  { code: 'PL', label: 'Polen' },
  { code: 'PT', label: 'Portugal' },
  { code: 'RO', label: 'Roemenië' },
  { code: 'SE', label: 'Zweden' },
  { code: 'SK', label: 'Slowakije' },
  { code: 'SL', label: 'Slovenië' },
  { code: 'XX', label: 'Onbekend' },
];
